/**
 * GitHub Authentication Service
 * Handles authentication flow for GitHub integration
 * Connects the account through provider-token-service
 * All authentication goes through BFF
 */

import providerLinkService from './ProviderLinkService';

class GitHubAuthService {
  /**
   * Check whether the user has connected this provider
   * @returns {Promise<boolean>}
   */
  async isAuthenticated() {
    try {
      const status = await providerLinkService.checkLinkStatus('github');
      return status.linked;
    } catch (error) {
      console.error('❌ GitHub authentication check error:', error);
      return false;
    }
  }

  /**
   * Disconnect the provider and clear local credentials
   * @returns {Promise<void>}
   */
  async logout() {
    try {
      await providerLinkService.unlinkProvider('github');
      console.log('✅ GitHub logout successful');
    } catch (error) {
      console.error('❌ GitHub logout error:', error);
      throw error;
    }
  }
}

const GitHubAuth = new GitHubAuthService();
export default GitHubAuth;
